export const API_GRAPHQL = 'https://api.xdustconverter.com/graphql';

export const sampleAuthenticatedDomains = ['http://localhost:3000'];

export const SLIPPAGE = [0.01, 0.02, 0.05, 0.1];
